import { render, staticRenderFns } from "./withdraw-unlock.vue?vue&type=template&id=4b8fb60e&scoped=true&"
import script from "./withdraw-unlock.vue?vue&type=script&lang=js&"
export * from "./withdraw-unlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8fb60e",
  null
  
)

export default component.exports